import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "sonner";
import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import BalanceSheet from "./pages/BalanceSheet";
import Transactions from "./pages/Transactions";
import Lifestyle from "./pages/Lifestyle";
import CashFlow from "./pages/CashFlow";
import Prices from "./pages/Prices";
import InvestmentCommittee from "./pages/InvestmentCommittee";
import { Pendaz, Smsf } from "./pages/Entities";
import Retirement from "./pages/Retirement";
import Property from "./pages/Property";
import Registers from "./pages/Registers";
import Reports from "./pages/Reports";
import Copilot from "./pages/Copilot";
import Users from "./pages/Users";
import Assumptions from "./pages/Assumptions";
import Insights from "./pages/Insights";
import Tax from "./pages/Tax";
import TaxPack from "./pages/TaxPack";
import TaxPackDrop from "./pages/TaxPackDrop";
import MoneyFlow from "./pages/MoneyFlow";

function Protected({ children }) {
    const { user } = useAuth();
    if (user === null) return <div className="min-h-screen flex items-center justify-center text-[var(--muted)]">Loading…</div>;
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function RedirectIfAuthed({ children }) {
    const { user } = useAuth();
    if (user === null) return null;
    if (user) return <Navigate to="/" replace />;
    return children;
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster richColors position="top-right" />
                <Routes>
                    <Route path="/drop/:token" element={<TaxPackDrop />} />
                    <Route path="/login" element={<RedirectIfAuthed><Login /></RedirectIfAuthed>} />
                    <Route element={<Protected><AppShell /></Protected>}>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/balance-sheet" element={<BalanceSheet />} />
                        <Route path="/transactions" element={<Transactions />} />
                        <Route path="/lifestyle" element={<Lifestyle />} />
                        <Route path="/cash-flow" element={<CashFlow />} />
                        <Route path="/money-flow" element={<MoneyFlow />} />
                        <Route path="/prices" element={<Prices />} />
                        <Route path="/investment-committee" element={<InvestmentCommittee />} />
                        <Route path="/pendaz" element={<Pendaz />} />
                        <Route path="/smsf" element={<Smsf />} />
                        <Route path="/retirement" element={<Retirement />} />
                        <Route path="/property" element={<Property />} />
                        <Route path="/registers" element={<Registers />} />
                        <Route path="/assumptions" element={<Assumptions />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/copilot" element={<Copilot />} />
                        <Route path="/insights" element={<Insights />} />
                        <Route path="/tax" element={<Tax />} />
                        <Route path="/tax-pack" element={<TaxPack />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
